module.exports = __webpack_public_path__ + "static/media/Workshop_Business_Trends.2c8ac014.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Workshop_Business_Trends.png
// module id = 239
// module chunks = 0